import { call } from 'redux-saga/effects';
import { trips } from 'mz-sdk';


/**
 * Get live pricing for a reservation from SDK and handle error.
 * Same endpoint change-booking uses to bootstrap its coupon/booking fee state.
 * @param  {string} id   The reservation hashed id
 */
export default function* handleReservationPricing(id) {
  try {
    const pricing = yield call(trips.getReservationPrice, { reservation_hashed_id: id });
    return pricing;
  } catch (error) {
    return null;
  }
}
